import React from 'react'
import { Helmet } from 'react-helmet'

/**
 * Header metadata component and page's title.
 * Query is isolated here to make layouts lighter.
 */
export const Meta = ({ title, extra = [] }) => (
  <Helmet title={title}>
    <html lang="en" />
    {extra.map((meta, key) => (
      <meta {...meta} key={key} />
    ))}
  </Helmet>
)
